import { Controller } from "stimulus"
import { showTarget, hideTarget } from '../../helpers/visibility'

export default class extends Controller {
  static targets = [
    "selectionPolicy",
    "fixedNumberFields"
  ]

  connect() {
    this.updateVisibility()
  }

  updateVisibility() {
    const selectionPolicy = this.selectionPolicyTarget.value

    if (selectionPolicy === "fixed_number") {
      showTarget(this.fixedNumberFieldsTarget)
    } else {
      hideTarget(this.fixedNumberFieldsTarget)
    }
  }
}